import React from "react";
import "../../../AllComponentCSS.css";

function JS_every() {
  return (
    <div className="tutorial-page">
      <h1>JS every</h1>
      <p>This page will cover the every topic in detail.</p>
    </div>
  );
}

export default JS_every;
